import React, { useState, useEffect } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input, } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import CustomSelect from '../../components/CustomSelect'
import { arrayForSelect } from '../../utils/arrayForSelect'
import moment from 'moment'
import { createEMK, getListModalTabeEMK, updateEMK } from '../../actions/educationalMethodologicalKits'
import { GET_LIST_MODAL_TAB_EMK } from '../../actions/types'
import { BiTrash } from 'react-icons/bi'
import Table from '../../components/Table'
import Button from '../../components/Button'
import { IoIosAdd, IoIosRefresh } from 'react-icons/io'
import ModalTab from './ModalTab/ModalTab'
import { getTypesOfDocumentsList } from '../../actions/typesOfDocuments'


const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})


export default function ModalComponent({ data, closeModal, height, addMode, lessons }) {

  const dispatch = useDispatch()

  const { teachers, courses } = useSelector(state => state.common)
  const { listTab } = useSelector(state => state.educationalMethodologicalKits)
  const { typeOfDocumentslist } = useSelector(state => state.types_of_documents)

  const [selectedTab, setSelectedTab] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [userModal, setUserModal] = useState()


  // 19.03.2026 - При addMode очищаем listTab, иначе загружаем данные
  useEffect(() => {
    if (addMode) {
      dispatch({ type: GET_LIST_MODAL_TAB_EMK, payload: [] })
    } else if (data.tkid) {
      dispatch(getListModalTabeEMK(data.tkid))
    }
    dispatch(getTypesOfDocumentsList())
  }, [])

  const openTabModal = (data) => () => {
    setSelectedTab(data || {})
  }
  const closeTabModal = () => {
    setSelectedTab(null)
  }

  const handleCreate = (values) => {
    dispatch(createEMK(values))
    closeModal()
  }

  const handleUpdate = (values) => {
    dispatch(updateEMK(values))
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue,
    handleBlur,
  } = useFormik({
    initialValues: data,
    enableReinitialize: true,
    validateOnChange: true,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]


  const openUserModal = () => {
    setUserModal(true)
  }

  const renderLi = (data) => {
    const { alias, stuffname, author, review, created, mid, lid, tkid, tksid } = data
    const currTeacher = teachers?.find(el => el.mid === mid) /// не совпадают йд-ки массивов
    return (
      <tr >
        <td onClick={openTabModal(data)}>{alias}</td>
        <td onClick={openTabModal(data)}>{stuffname}</td>
        <td onClick={openTabModal(data)}>{author}</td>
        <td onClick={openTabModal(data)}>{created}</td>
        <td onClick={openTabModal(data)}>{review}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: tksid, name: stuffname })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        modal: styles.custom
      }}
      center
    >
      <>
        {selectedTab &&
          <ModalTab
            closeModal={closeTabModal}
            data={selectedTab}
            typeOfDocumentslist={typeOfDocumentslist}
          />
        }
        <div className={styles.modalMain}>
          <div className={styles.tabsHeader}>
            <div className={styles.title}>{!addMode
              ? 'Редактирование'
              : 'Добавление'}</div>

          </div>
        </div>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            <Input
              label='Название'
              name='kitname'
              value={values?.kitname}
              error={error('kitname')}
              onChange={handleChange}
              style={{ width: '600px' }}
            />
            <div className={styles.inputsRow}>
              <CustomSelect
                title="Дисциплина"
                valuesName="lesson"
                value={values?.lid}
                options={lessons && arrayForSelect(lessons, 'name', 'lid')}
                setFieldValue={setFieldValue}
              />
              <CustomSelect
                title='Преподаватель'
                valuesName="mid"
                value={values?.mid}
                options={teachers && arrayForSelect(teachers, 'calc_fio', 'mid')}
                setFieldValue={setFieldValue}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Период (начало)'
                name='start_date'
                type='date'
                value={moment(values?.start_date).format('YYYY-MM-DD')}
                error={error('start_date')}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <Input
                label='Период (конец)'
                name='end_date'
                type='date'
                value={moment(values?.end_date).format('YYYY-MM-DD')}
                error={error('end_date')}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
          <Table className={styles.tables}>
            <thead>
              <tr>
                <th>Сохр.</th>
                <th>Материал</th>
                <th>Автор</th>
                <th>дата создания</th>
                <th>Рецензия</th>
                <th>Удалить</th>
              </tr>
            </thead>
            <tbody>
              {listTab && listTab.map(renderLi)}
            </tbody>
          </Table>
          <div style={{ display: 'flex', flexDirection: "row" }}>
            <Button
              style={{ padding: '.5rem 1.5rem', margin: '12px' }}
              onClick={openTabModal()}
            >
              <IoIosAdd size={30} />
              Добавить
            </Button>
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>

      {userModal &&
        <Modal
          open={userModal}
          onClose={() => setUserModal(false)}
          height={height}
          classNames={{
            modal: styles.custom
          }}
          center>
          <div>
            <div className={styles.inputsRow}>
              <Input
                label='Название'
                name='group_name'
                value={values.group_name}
                error={error('group_name')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />

            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Короткое название'
                name='shortname'
                value={values.shortname}
                onChange={handleChange}
                style={{ width: '600px' }}
              />

            </div>
          </div>
          <ModalFooter handleSubmit={handleSubmit} closeModal={() => setUserModal(false)} />
        </Modal>
      }
    </Modal >

  )
}
